"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContracts = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const get_contracts_constants_1 = require("./get-contracts.constants");
const get_contracts_query_1 = require("./get-contracts.query");
const useContracts = (projectId) => {
    const _a = (0, react_2.useQuery)(get_contracts_query_1.GET_CONTRACTS, {
        variables: {
            projectId,
            optionsToCheck: get_contracts_constants_1.CONTRACT_OPTIONS_TO_CHECK,
        },
        skip: !projectId,
        fetchPolicy: 'cache-first',
    }), { data } = _a, rest = __rest(_a, ["data"]);
    const contracts = (0, react_1.useMemo)(() => { var _a, _b, _c, _d, _e; return (_e = (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.projects) === null || _a === void 0 ? void 0 : _a.edges[0]) === null || _b === void 0 ? void 0 : _b.node) === null || _c === void 0 ? void 0 : _c.contracts) === null || _d === void 0 ? void 0 : _d.edges.map(({ node }) => node)) !== null && _e !== void 0 ? _e : []; }, [data]);
    return Object.assign(Object.assign({}, rest), { contracts });
};
exports.useContracts = useContracts;
